import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ProfileFieldProps {
  label: string;
  id: string;
  value: string;
  onChange?: (value: string) => void;
  isEditing: boolean;
  placeholder?: string;
  type?: string;
}

export const ProfileField = ({
  label,
  id,
  value,
  onChange,
  isEditing,
  placeholder,
  type = "text"
}: ProfileFieldProps) => {
  return (
    <div>
      <Label htmlFor={id} className="text-sm font-medium text-muted-foreground">
        {label}
      </Label>
      {isEditing ? (
        <Input
          id={id}
          type={type}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          className="mt-1"
          placeholder={placeholder}
        />
      ) : (
        <p className="text-lg">{value || 'Not set'}</p>
      )}
    </div>
  );
};